import { css } from 'styled-components';
import { HowItWorksProps } from './models';

export const HowItWorks = css<HowItWorksProps>(({ theme }) => {
  return css`
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 8px;
    background: ${theme.colors.lighterBlue};
    padding: 20px 8px;
    @media only screen and ${theme.device.tablet} {
      padding: 12px 32px;
    }
    width: 100%;

    @media only screen and ${theme.device.tablet} {
      flex-direction: row;
    }

    > .text-section {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 4px;
      @media only screen and ${theme.device.tablet} {
        gap: 16px;
        padding-right: 16px;

        align-items: flex-start;
      }
      > .title {
        color: ${theme.colors.primaryDeepBlue};
        text-align: center;
        font-size: 18px;
        font-weight: 700;
        line-height: normal;
        @media only screen and ${theme.device.tablet} {
          width: 104px;
          text-align: left;
        }
      }

      > .subtitle {
        color: ${theme.colors.primaryDeepBlue};
        text-align: center;
        font-size: 12px;
        font-weight: 600;
        line-height: normal;
      }
    }

    > .step {
      flex: 1;
      display: flex;
      align-items: center;
      align-self: flex-start;
      gap: 8px;
      padding: 16px 12px;
      box-sizing: border-box;
      color: ${theme.colors.primaryDeepBlue};
      font-size: 14px;
      font-weight: 400;
      text-align: center;

      @media only screen and ${theme.device.tablet} {
        flex-direction: column;
        align-self: stretch;
        text-align: center;
      }

      > .step-icon {
        width: 40px;
        height: 40px;
        flex-shrink: 0;
      }
    }
  `;
});
